import { useRef } from 'react';
import { TextButton } from 'Components/Button';
import CommonFormatsBody from 'Components/Public/CommonFormats/CommonFormatsBody';
import { DATA_SECURITY_DATA } from './DataSecurityData';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';
import Feedback from "../../../Components/Public/Feedback/Feedback";
import {NextPage} from "../../../Components/Public/NextPage/NextPage";
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";

const { LeftPageHeader } = require("Components/Public/PageHeader/PageHeader")

const DataSecurity = () => {
  
  const sectionRefs = useRef({});
  const navigate = useNavigate();
  
  // to login page
  const handleLogin = () => {
    navigate(
      PATHS.public['Sign In']
    );
  }
  
  return (
    <ReCaptchaWrapper
      action="data_security_landing"
      title="Data Security & Privacy"
    >
      <LeftPageHeader
        subTitle=""
        title="Data Security & Privacy at PSOPPC"
        //intro="PSO Privacy Protection Center"
        rightContent={
          <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content ms-auto me-auto h-100 justify-content-center mt-2 mb-2">
            
            <TextButton
              variant={"normal"}
              onClick={handleLogin}
              content={"Login to Submit Data"}
              className="button-width"
            />
          </div>
        }>
      </LeftPageHeader>
      <CommonFormatsBody commonFormatsData={DATA_SECURITY_DATA} ref={sectionRefs} />
      <Feedback/>
      
      <NextPage
        backPath={PATHS.public['Learn from the Data']}
        backPathText="Learn from the Data"
      ></NextPage>
    </ReCaptchaWrapper>
  )
}

export default DataSecurity;
